import { Badge } from '@yeshuman/sdk'
import type { BriefSkill } from '../../hooks/use-briefs'

export type BriefSkillsBadgesProps = {
  skills: BriefSkill[]
  className?: string
}

export function BriefSkillsBadges({ skills, className }: BriefSkillsBadgesProps) {
  const required = skills.filter((s) => s.requirement_type === 'required')
  const preferred = skills.filter((s) => s.requirement_type === 'preferred')

  if (skills.length === 0) {
    return <p className="text-sm text-muted-foreground">No skills yet</p>
  }

  return (
    <div className={className}>
      {required.length > 0 ? (
        <div className="space-y-2">
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Required</p>
          <div className="flex flex-wrap gap-2">
            {required.map((skill) => (
              <Badge key={skill.id} variant="default">
                {skill.skill_name}
              </Badge>
            ))}
          </div>
        </div>
      ) : null}
      {preferred.length > 0 ? (
        <div className={required.length > 0 ? 'mt-4 space-y-2' : 'space-y-2'}>
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Preferred</p>
          <div className="flex flex-wrap gap-2">
            {preferred.map((skill) => (
              <Badge key={skill.id} variant="outline">
                {skill.skill_name}
              </Badge>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  )
}
